import React, {useState} from "react";
import {Button, Divider, Form, Grid, Image, Message} from "semantic-ui-react";

import './signup.css';
import {NavLink, useHistory} from "react-router-dom";
import {useForm} from "react-hook-form";
import InputMask from 'react-input-mask';
import moment from "moment";
import {postPeoples} from "../../../redux/actions";
import {FormattedMessage, useIntl} from "react-intl";

export const Signup = () => {

    const history = useHistory();
    const [error, setError] = useState('');
    const success = useIntl().formatMessage({id: 'Cadastro efetuado com sucesso!'});
    const failure = useIntl().formatMessage({id: 'Este e-mail já esta sendo utilizado'});
    const values = new URLSearchParams(window.top.location.search);

    window.scrollTo(0, 0);

    const {register, handleSubmit, formState} = useForm({
        mode: 'onChange',
        defaultValues: {
            name: '',
            email: '',
            birthday: '',
            instagram: '',
            user: {
                password: ''
            }
        }
    });

    const {isValid, isSubmitting} = formState;

    const onSubmit = async data => {
        setError('');

        try {
            let date = data.birthday
            let content = {...data};
            content['birthday'] = date.substr(6, 4) + '-' + date.substr(3, 2) + '-' + date.substr(0,2);

            const m = moment(content['birthday']);
            if (!m.isValid()) {
                alert('Data inválida');
            }

            await postPeoples(content);
            const goback = localStorage.getItem('goback');

            alert(success);
            if(values.get('goback')){
                window.top.location.href = values.get('goback');
            }

            if(goback){
                localStorage.removeItem(goback);
                window.location.href = goback;
                return;
            }

            history.push('/users/login/0');
        } catch (e) {
            setError(failure)
        }
    };

    return (
        <Grid stackable style={{border: '4px solid red', margin: '32px 0'}}>
            <Grid.Row columns={"two"}>
                <Grid.Column
                    only='large screen'
                    style={{
                        backgroundImage: 'url(/images/login-bg.jpg)',
                        backgroundPosition: 'top center',
                    }}
                />
                <Grid.Column className={"signup-form"} textAlign={"center"}>
                    <Image src={"/images/logo-footer-geral.png"} width={160}/>
                    <h3><FormattedMessage id={"Crie uma conta grátis"}/></h3>
                    <p><FormattedMessage id={"Para ter acesso a conteúdos exclusivos, crie uma conta grátis entrando com seus dados abaixo:"}/></p>
                    {
                        error && <Message error content={error}/>
                    }
                    <Form
                        onSubmit={handleSubmit(onSubmit)}
                        loading={isSubmitting}
                        style={{
                            textAlign: "left",
                            width: "90%",
                            maxWidth: "90%",
                            margin: "0 auto"
                        }}
                    >
                        <Form.Field>
                            <label><FormattedMessage id={"Nome completo"}/></label>
                            <input
                                name={'name'}
                                ref={register({required: true})}
                                // placeholder={useIntl().formatMessage({id: 'Nome'})}
                                defaultValue={''}
                                autoFocus
                            />
                        </Form.Field>
                        <Form.Field>
                            <label><FormattedMessage id={"E-mail"}/></label>
                            <input
                                name={'email'}
                                ref={register({required: true})}
                                // placeholder={useIntl().formatMessage({id: 'E-mail'})}
                                defaultValue={''}
                            />
                        </Form.Field>
                        <Form.Field>
                            <label><FormattedMessage id={"Data de nascimento"}/></label>
                            {/*<input*/}
                            {/*    className={"ui input"}*/}
                            {/*    name={'birthday'}*/}
                            {/*    // type={'date'}*/}
                            {/*    ref={register({required: true})}*/}
                            {/*    // placeholder={useIntl().formatMessage({id: 'Data de Nascimento'})}*/}
                            {/*    defaultValue={''}*/}
                            {/*/>*/}
                            {/*<InputMask*/}
                            {/*    className={"ui input"}*/}
                            {/*    name={'birthday'}*/}
                            {/*    ref={register({required: true})}*/}
                            {/*    defaultValue={''}*/}
                            {/*    mask={"99/99/9999"}*/}
                            {/*    onChange={(e) => console.log(e.target.value)}*/}
                            {/*>*/}

                            {/*</InputMask>*/}
                            <InputMask
                                mask={"99/99/9999"}
                            >
                                {() =>
                                <input
                                    className={"ui input"}
                                    name={'birthday'}
                                    ref={register({required: true})}
                                    // placeholder={useIntl().formatMessage({id: 'Data de Nascimento'})}
                                    defaultValue={''}
                                />
                                }
                            </InputMask>
                        </Form.Field>
                        <Form.Field>
                            <label><FormattedMessage id={"Instagram"}/></label>
                            <input
                                name={'instagram'}
                                ref={register({required: true})}
                                // placeholder='@instagram'
                                defaultValue={''}
                            />
                        </Form.Field>
                        <Form.Field>
                            <label><FormattedMessage id={"Senha"}/></label>
                            <input
                                type={'password'}
                                name={'user.password'}
                                ref={register({required: true})}
                                // placeholder={useIntl().formatMessage({id: 'Senha'})}
                                defaultValue={''}
                            />
                        </Form.Field>
                        <Button
                            disabled={!isValid}
                            fluid
                            type='submit'
                            color={"red"}
                            content={useIntl().formatMessage({id: 'ENVIAR'})}
                        />
                    </Form>
                    <Divider section/>
                    <h2><FormattedMessage id={"Já possuo cadastro no INBH"}/></h2>
                    <Button
                        basic
                        type={"button"}
                        color={"red"}
                        onClick={() => history.push('/users/login/0')}
                        content={useIntl().formatMessage({id: 'FAZER LOGIN'})}
                    />
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
}